// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';

export const SettingsHttpGetAiConsentEvents =
  'SettingsHttpGetAiConsentEvents' as const;
export const SettingsHttpGetAiConsents = 'SettingsHttpGetAiConsents' as const;
export const SettingsHttpPostAiConsents = 'SettingsHttpPostAiConsents' as const;
export const SettingsHttpPostAiConsentsDecline =
  'SettingsHttpPostAiConsentsDecline' as const;
export const SettingsHttpPostAiConsentsRevoke =
  'SettingsHttpPostAiConsentsRevoke' as const;
export const SettingsHttpGetAiDocuments = 'SettingsHttpGetAiDocuments' as const;
export const SettingsHttpGetCorsHosts = 'SettingsHttpGetCorsHosts' as const;
export const SettingsHttpPostCorsHosts = 'SettingsHttpPostCorsHosts' as const;
export const SettingsHttpDeleteCorsHostsByCorsHostId =
  'SettingsHttpDeleteCorsHostsByCorsHostId' as const;
export const SettingsHttpGetCorsHostsByCorsHostId =
  'SettingsHttpGetCorsHostsByCorsHostId' as const;
export const SettingsHttpDeleteGroupByGroupId =
  'SettingsHttpDeleteGroupByGroupId' as const;
export const SettingsHttpGetGroupByGroupId =
  'SettingsHttpGetGroupByGroupId' as const;
export const SettingsHttpPatchGroupByGroupId =
  'SettingsHttpPatchGroupByGroupId' as const;
export const SettingsHttpPutGroupByGroupId =
  'SettingsHttpPutGroupByGroupId' as const;
export const SettingsHttpGetMergedCurrent =
  'SettingsHttpGetMergedCurrent' as const;
export const SettingsHttpGetMergedByUserId =
  'SettingsHttpGetMergedByUserId' as const;
export const SettingsHttpDeleteSearchViewByViewIdGroupIds =
  'SettingsHttpDeleteSearchViewByViewIdGroupIds' as const;
export const SettingsHttpGetSearchViewByViewIdGroupIds =
  'SettingsHttpGetSearchViewByViewIdGroupIds' as const;
export const SettingsHttpPatchSearchViewByViewIdGroupIds =
  'SettingsHttpPatchSearchViewByViewIdGroupIds' as const;
export const SettingsHttpPutSearchViewByViewIdGroupIds =
  'SettingsHttpPutSearchViewByViewIdGroupIds' as const;
export const SettingsHttpGetSystemCurrent =
  'SettingsHttpGetSystemCurrent' as const;
export const SettingsHttpPatchSystemCurrent =
  'SettingsHttpPatchSystemCurrent' as const;
export const SettingsHttpPutSystemCurrent =
  'SettingsHttpPutSystemCurrent' as const;
export const SettingsHttpGetSystemBySystemDomainId =
  'SettingsHttpGetSystemBySystemDomainId' as const;
export const SettingsHttpPatchSystemBySystemDomainId =
  'SettingsHttpPatchSystemBySystemDomainId' as const;
export const SettingsHttpPutSystemBySystemDomainId =
  'SettingsHttpPutSystemBySystemDomainId' as const;
export const SettingsHttpDeleteTeamByTeamId =
  'SettingsHttpDeleteTeamByTeamId' as const;
export const SettingsHttpGetTeamByTeamId =
  'SettingsHttpGetTeamByTeamId' as const;
export const SettingsHttpPatchTeamByTeamId =
  'SettingsHttpPatchTeamByTeamId' as const;
export const SettingsHttpPutTeamByTeamId =
  'SettingsHttpPutTeamByTeamId' as const;
export const SettingsHttpGetThemes = 'SettingsHttpGetThemes' as const;
export const SettingsHttpPostThemes = 'SettingsHttpPostThemes' as const;
export const SettingsHttpDeleteThemesByThemeId =
  'SettingsHttpDeleteThemesByThemeId' as const;
export const SettingsHttpGetThemesByThemeId =
  'SettingsHttpGetThemesByThemeId' as const;
export const SettingsHttpPatchThemesByThemeId =
  'SettingsHttpPatchThemesByThemeId' as const;
export const SettingsHttpPutThemesByThemeId =
  'SettingsHttpPutThemesByThemeId' as const;
export const SettingsHttpDeleteUserByUserId =
  'SettingsHttpDeleteUserByUserId' as const;
export const SettingsHttpGetUserByUserId =
  'SettingsHttpGetUserByUserId' as const;
export const SettingsHttpPatchUserByUserId =
  'SettingsHttpPatchUserByUserId' as const;
export const SettingsHttpPutUserByUserId =
  'SettingsHttpPutUserByUserId' as const;

/**
 * Original schema `AIConsentAcceptSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentAcceptSchema}
 */
export interface SettingsAIConsentAcceptSchema {
  /**
   * @minItems 1
   * @maxItems 20
   */
  documents: SettingsAIConsentDocumentRef[];
}
/**
 * Original schema `AIConsentDocumentRef`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentDocumentRef}
 */
export interface SettingsAIConsentDocumentRef {
  id: string;
  version: string;
}
/**
 * Original schema `AIConsentDeclineRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentDeclineRequestSchema}
 */
export interface SettingsAIConsentDeclineRequestSchema {
  /**
   * @minItems 1
   * @maxItems 20
   */
  documents: SettingsAIConsentDocumentRef[];
}
/**
 * Original schema `AIConsentDocumentRefSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentDocumentRefSchema}
 */
export interface SettingsAIConsentDocumentRefSchema {
  id: string;
  version: string;
}
/**
 * Original schema `AIConsentDocumentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentDocumentSchema}
 */
export interface SettingsAIConsentDocumentSchema {
  id?: string;
  /**
   * ISO 8601 date this version was published.
   */
  published_at?: string | null;
  title?: string;
  url?: string;
  version?: string;
}
/**
 * Original schema `AIConsentDocumentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentDocumentsSchema}
 */
export interface SettingsAIConsentDocumentsSchema {
  objects?: SettingsAIConsentDocumentSchema[];
}
/**
 * Original schema `AIConsentEventSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentEventSchema}
 */
export interface SettingsAIConsentEventSchema {
  acting_as_user_id?: string | null;
  action?:
    | 'ACCEPTED'
    | 'DECLINED'
    | 'REVOKED'
    | 'REVOKED_BY_MASTER_SWITCH'
    | 'LEGACY_IMPORTED'
    | 'NOTICE_ELAPSED';
  app_id?: string | null;
  date_created?: string;
  document_id?: string | null;
  document_url?: string | null;
  document_version?: string | null;
  evidence?: string | null;
  id?: string;
  ip?: string | null;
  origin?: string | null;
  user_email?: string | null;
  user_id?: string | null;
}
/**
 * Original schema `AIConsentEventsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentEventsSchema}
 */
export interface SettingsAIConsentEventsSchema {
  objects?: SettingsAIConsentEventSchema[];
}
/**
 * Original schema `AIConsentRevokeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentRevokeSchema}
 */
export interface SettingsAIConsentRevokeSchema {
  /**
   * Document ids to revoke.
   *
   * @minItems 1
   * @maxItems 20
   */
  documents: string[];
}
/**
 * Original schema `AIConsentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentSchema}
 */
export interface SettingsAIConsentSchema {
  date_created?: string | null;
  date_revoked?: string | null;
  document_id?: string;
  document_url?: string | null;
  evidence?: string | null;
  origin?:
    | (
        | 'ADMIN_ACCEPTED'
        | 'LEGACY_UI_CONSENT'
        | 'LEGACY_BETA_AGREEMENT'
        | 'NOTICE_ELAPSED'
      )
    | null;
  status?: 'GRANTED' | 'REVOKED' | 'DECLINED';
  version?: string;
}
/**
 * Original schema `AIConsentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentsSchema}
 */
export interface SettingsAIConsentsSchema {
  objects?: SettingsAIConsentSchema[];
}
/**
 * Original schema `AIFeatureStateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIFeatureStateSchema}
 */
export interface SettingsAIFeatureStateSchema {
  /**
   * Billing tiers that grant this feature, as an alternative to its feature flag. Empty when no tier does: the feature is then gated on the flag alone.
   */
  billing_tiers?: string[];
  /**
   * False while the interface for accepting this feature's terms is still being built: `documents_to_accept` is reported as usual, but it neither blocks enabling the feature nor masks it off.
   */
  consent_enforced?: boolean;
  /**
   * Accept these to satisfy what this feature is missing. Empty when nothing is.
   */
  documents_to_accept?: SettingsAIConsentDocumentSchema[];
  /**
   * What the feature actually does. False as soon as the master switch is off, the consent is missing or stale, or the domain lost the entitlement.
   */
  effective?: boolean;
  /**
   * What the administrator asked for.
   */
  enabled?: boolean;
  id?: string;
  setting_name?: string;
  status?:
    | 'UNAVAILABLE'
    | 'DISABLED'
    | 'CONSENT_REQUIRED'
    | 'CONSENT_STALE'
    | 'ENABLED';
}
/**
 * Original schema `AIStateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIStateSchema}
 */
export interface SettingsAIStateSchema {
  /**
   * Every position this customer has taken, accepted and refused alike. A refusal does not switch anything off by itself: it stops the terms taking effect by non-objection.
   */
  consents?: SettingsAIConsentSchema[];
  /**
   * The platform forbids AI on this system domain. Every feature reads as UNAVAILABLE and nothing can be enabled. Not something the customer can change; the interface should explain rather than offer a switch.
   */
  disabled_by_domain?: boolean;
  /**
   * Master switch.
   */
  enabled?: boolean;
  features?: {
    [k: string]: SettingsAIFeatureStateSchema;
  };
}
/**
 * Original schema `AllowedIPSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AllowedIPSchema}
 */
export interface SettingsAllowedIPSchema {
  app_id?: string | null;
  ip?: string;
}
/**
 * Original schema `CORSHostSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-CORSHostSchema}
 */
export interface SettingsCORSHostSchema {
  host: string;
  id?: string;
}
/**
 * Original schema `CORSHostsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-CORSHostsSchema}
 */
export interface SettingsCORSHostsSchema {
  objects?: SettingsCORSHostSchema[];
}
/**
 * Original schema `DashboardCollectionsTreeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-DashboardCollectionsTreeSchema}
 */
export interface SettingsDashboardCollectionsTreeSchema {
  visible?: boolean;
}
/**
 * Original schema `DashboardCommentsFeedSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-DashboardCommentsFeedSchema}
 */
export interface SettingsDashboardCommentsFeedSchema {
  visible?: boolean;
}
/**
 * Original schema `DashboardHeaderSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-DashboardHeaderSchema}
 */
export interface SettingsDashboardHeaderSchema {
  expanded?: boolean;
}
/**
 * Original schema `DashboardSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-DashboardSchema}
 */
export interface SettingsDashboardSchema {
  collections_tree?: SettingsDashboardCollectionsTreeSchema | null;
  comments_feed?: SettingsDashboardCommentsFeedSchema | null;
  header?: SettingsDashboardHeaderSchema | null;
  view_type?: 'card' | 'list';
  widgets?: SettingsDashboardWidget[];
}
/**
 * Original schema `DashboardWidget`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-DashboardWidget}
 */
export interface SettingsDashboardWidget {
  expanded?: boolean;
  id?: string;
  visible?: boolean;
}
/**
 * Original schema `DashboardWidgetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-DashboardWidgetSchema}
 */
export interface SettingsDashboardWidgetSchema {
  expanded?: boolean;
  id?: string;
  visible?: boolean;
}
/**
 * Original schema `DefaultShareOptionsTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-DefaultShareOptionsTypeSchema}
 */
export interface SettingsDefaultShareOptionsTypeSchema {
  allow_approving_comments?: boolean;
  allow_comments?: boolean;
  allow_custom_actions?: boolean;
  allow_download?: boolean;
  allow_download_proxy?: boolean;
  allow_setting_approve_status?: boolean;
  allow_upload?: boolean;
  allow_view_transcriptions?: boolean;
  allow_view_versions?: boolean;
  can_change_allow_approving_comments?: boolean;
  can_change_allow_comments?: boolean;
  can_change_allow_custom_actions?: boolean;
  can_change_allow_download?: boolean;
  can_change_allow_download_proxy?: boolean;
  can_change_allow_setting_approve_status?: boolean;
  can_change_allow_upload?: boolean;
  can_change_allow_view_transcriptions?: boolean;
  can_change_allow_view_versions?: boolean;
  can_change_search_users_from_share?: boolean;
  can_change_share_expiration_time?: boolean;
  can_change_show_existing_comments?: boolean;
  can_change_show_watermark?: boolean;
  require_password?: boolean;
  show_existing_comments?: boolean;
  show_watermark?: boolean;
}
/**
 * Original schema `ExternalShareOptionsTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ExternalShareOptionsTypeSchema}
 */
export interface SettingsExternalShareOptionsTypeSchema {
  groups?: string[] | null;
  show_for_groups?: ('all' | 'selected_only' | 'except') | null;
}
/**
 * Original schema `FacetFieldSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-FacetFieldSchema}
 */
export interface SettingsFacetFieldSchema {
  name: string;
}
/**
 * Original schema `GlobalSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-GlobalSettingsSchema}
 */
export interface SettingsGlobalSettingsSchema {
  debug?: boolean;
  log_level?: 'NOTSET' | 'DEBUG' | 'INFO' | 'WARNING' | 'ERROR' | 'CRITICAL';
}
/**
 * Original schema `GroupSettingPublicSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-GroupSettingPublicSchema}
 */
export interface SettingsGroupSettingPublicSchema {
  acl_template_id?: string | null;
  /**
   * @minItems 0
   * @maxItems 100
   */
  allowed_ips?: SettingsAllowedIPSchema[];
  append_asset_uuid_to_downloads?: boolean | null;
  asset_default_sections?: string[];
  client_ip?: string;
  collections_get_parent_acls?: boolean | null;
  date_format?: string | null;
  datetime_format?: string | null;
  default_upload_storage_id?: string | null;
  /**
   * Grace period that indicate how long objects will live in recycle bin. Unit: hours
   */
  delete_grace_period?: number | null;
  facet_fields?: SettingsFacetFieldSchema[];
  filters_default_metadata_view_id?: string | null;
  group_id?: string;
  hide_favourites?: boolean | null;
  home_page?: string | null;
  jobs_dashboard?: SettingsJobsDashboard | null;
  logo_storage_id?: string | null;
  logo_url?: string;
  required_metadata_views?: string[];
  search_auto_resize_title_column?: boolean | null;
  search_default_sections?: string[];
  search_display_fields?: SettingsSearchDisplayField[];
  search_in_transcriptions?: boolean | null;
  search_results_asset_metadata_view_id?: string | null;
  search_results_collection_metadata_view_id?: string | null;
  search_view_id?: string | null;
  /**
   * Default share expiration time that indicate how long share will be valid. Unit: days
   */
  share_expiration_time?: number | null;
  system_domain_id?: string;
  use_asset_name_on_download?: boolean | null;
}
/**
 * Original schema `JobsDashboard`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-JobsDashboard}
 */
export interface SettingsJobsDashboard {
  widgets?: SettingsJobsDashboardWidget[];
}
/**
 * Original schema `JobsDashboardWidget`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-JobsDashboardWidget}
 */
export interface SettingsJobsDashboardWidget {
  id?: string;
  options?: SettingsJobsWidgetOption;
  title?: string | null;
  type?: 'JOBS_LIST' | 'JOBS_STATS_LIST';
}
/**
 * Original schema `JobsWidgetOption`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-JobsWidgetOption}
 */
export interface SettingsJobsWidgetOption {
  columns?: string[];
  filters?: {
    [k: string]: unknown;
  };
  limit?: number;
  sort?: SettingsSort[];
}
/**
 * Original schema `Sort`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-Sort}
 */
export interface SettingsSort {
  name: string;
  order?: 'asc' | 'desc';
}
/**
 * Original schema `SearchDisplayField`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-SearchDisplayField}
 */
export interface SettingsSearchDisplayField {
  name: string;
}
/**
 * Original schema `GroupSettingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-GroupSettingSchema}
 */
export interface SettingsGroupSettingSchema {
  group_id?: string;
  logo_storage_id?: string | null;
  logo_url?: string | null;
  system_domain_id?: string;
}
/**
 * Original schema `GroupSettingsIDSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-GroupSettingsIDSchema}
 */
export interface SettingsGroupSettingsIDSchema {
  /**
   * @minItems 0
   * @maxItems 500
   */
  object_ids: string[];
}
/**
 * Original schema `JobsDashboardSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-JobsDashboardSchema}
 */
export interface SettingsJobsDashboardSchema {
  widgets?: SettingsJobsDashboardWidget[];
}
/**
 * Original schema `JobsDashboardWidgetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-JobsDashboardWidgetSchema}
 */
export interface SettingsJobsDashboardWidgetSchema {
  id?: string;
  options?: SettingsJobsWidgetOption;
  title?: string | null;
  type?: 'JOBS_LIST' | 'JOBS_STATS_LIST';
}
/**
 * Original schema `JobsWidgetOptionFilterSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-JobsWidgetOptionFilterSchema}
 */
export interface SettingsJobsWidgetOptionFilterSchema {
  name?: string | null;
  value?: string[];
}
/**
 * Original schema `JobsWidgetOptionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-JobsWidgetOptionSchema}
 */
export interface SettingsJobsWidgetOptionSchema {
  columns?: string[];
  filters?: {
    [k: string]: unknown;
  };
  limit?: number;
  sort?: SettingsSort[];
}
/**
 * Original schema `MergedSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-MergedSettingsSchema}
 */
export interface SettingsMergedSettingsSchema {
  acl_template_id?: string | null;
  ai?: SettingsAIStateSchema;
  allow_invites_by_link?: boolean | null;
  allow_mobile_upload_without_required_metadata?: boolean | null;
  /**
   * Allow playing the original file while transcoding is in progress.
   */
  allow_play_original_during_transcoding?: boolean | null;
  allow_share_magic_link_creation?: boolean | null;
  /**
   * @minItems 0
   * @maxItems 100
   */
  allowed_ips?: SettingsAllowedIPSchema[];
  append_asset_uuid_to_downloads?: boolean | null;
  asset_default_sections?: string[];
  billing_tier?: string;
  client_ip?: string;
  collections_get_parent_acls?: boolean | null;
  cors_hosts?: string[];
  custom_terms?: boolean;
  /**
   * URL to a CuttingRoom tenant. (e.g https://tenant.region.cuttingroom.com)
   */
  cuttingroom_url?: string | null;
  dashboard?: SettingsDashboardSchema | null;
  date_format?: string | null;
  datetime_format?: string | null;
  /**
   * Default time to live for app tokens in seconds.
   */
  default_app_token_ttl?: number | null;
  /**
   * Default time to live for refresh tokens in seconds.
   */
  default_refresh_token_ttl?: number | null;
  default_share_options?: SettingsDefaultShareOptionsTypeSchema | null;
  default_upload_storage_id?: string | null;
  /**
   * Default time to live for user tokens in seconds.
   */
  default_user_token_ttl?: number | null;
  /**
   * Grace period that indicate how long objects will live in recycle bin. Unit: hours
   */
  delete_grace_period?: number | null;
  disable_billing_page?: boolean;
  domain_has_preloaded_assets?: boolean;
  /**
   * DRM setting
   */
  drm?: ('none' | 'standard') | null;
  /**
   * Whether to require hardware DRM for playback when DRM is enabled
   */
  drm_enforce?: boolean | null;
  /**
   * Master switch for AI features.
   */
  enable_ai?: boolean;
  enable_ai_metadata_filling?: boolean | null;
  enable_face_recognition?: boolean | null;
  enable_nltf?: boolean | null;
  enable_portals?: boolean | null;
  enable_shield?: boolean | null;
  /**
   * When enabled, magic links can only be sent to allowlisted emails/domains
   */
  enforce_magic_link_allowlist?: boolean | null;
  external_share?: boolean | null;
  external_share_options?: SettingsExternalShareOptionsTypeSchema | null;
  facet_fields?: SettingsFacetFieldSchema[];
  features?: string[];
  filters_default_metadata_view_id?: string | null;
  genesis?: string | null;
  group_id?: string;
  hide_favourites?: boolean | null;
  home_page?: string | null;
  image_properties_metadata_field?: string | null;
  is_plg_domain?: boolean;
  jobs_dashboard?: SettingsJobsDashboardSchema | null;
  locations_metadata_field?: string | null;
  /**
   * Forbid regular users to edit or delete mapped collections.
   */
  lock_mapped_collections?: boolean | null;
  logo_storage_id?: string | null;
  logo_url?: string;
  logos_metadata_field?: string | null;
  max_browse_users?: number | null;
  max_power_users?: number | null;
  max_standard_users?: number | null;
  max_storage_bytes?: number | null;
  max_traffic_bytes?: number | null;
  mfa_methods?: ('TOTP' | 'MAIL_2SV')[] | null;
  mfa_required?: boolean | null;
  password_checks?: SettingsPasswordChecksType | null;
  require_limit_download_groups?: boolean | null;
  required_metadata_views?: string[];
  review_experience_disabled?: boolean | null;
  review_experience_disabled_per_share?: boolean | null;
  safe_searches_metadata_field?: string | null;
  saml_require_groups?: boolean | null;
  search_auto_resize_title_column?: boolean | null;
  search_default_sections?: string[];
  search_display_fields?: SettingsSearchDisplayField[];
  search_in_transcriptions?: boolean | null;
  search_results_asset_metadata_view_id?: string | null;
  search_results_collection_metadata_view_id?: string | null;
  search_users_from_share?: boolean | null;
  search_view_id?: string | null;
  /**
   * Default share expiration time that indicate how long share will be valid. Unit: days
   */
  share_expiration_time?: number | null;
  show_persons_confirmation_modal?: boolean | null;
  support_access?: boolean | null;
  system_domain_id?: string;
  system_domain_name?: string;
  tags_metadata_field?: string | null;
  texts_metadata_field?: string | null;
  update_saml_primary_group_on_login?: boolean | null;
  usage_history?: SettingsUsageHistory | null;
  use_asset_name_on_download?: boolean | null;
  /**
   * Watermark setting
   */
  watermark?: ('none' | 'standard') | null;
  watermark_options?: SettingsWatermarkOptionsType | null;
}
/**
 * Original schema `PasswordChecksType`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-PasswordChecksType}
 */
export interface SettingsPasswordChecksType {
  digits?: number | null;
  lowercase?: number | null;
  max_length?: number | null;
  min_length?: number | null;
  special_symbols?: number | null;
  uppercase?: number | null;
}
/**
 * Original schema `UsageHistory`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-UsageHistory}
 */
export interface SettingsUsageHistory {
  widgets?: SettingsUsageHistoryWidget[];
}
/**
 * Original schema `UsageHistoryWidget`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-UsageHistoryWidget}
 */
export interface SettingsUsageHistoryWidget {
  expanded?: boolean;
  id?: string;
}
/**
 * Original schema `WatermarkOptionsType`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-WatermarkOptionsType}
 */
export interface SettingsWatermarkOptionsType {
  custom_text?: string;
  groups?: string[] | null;
  include_custom_text?: boolean;
  include_date_time?: boolean;
  include_email?: boolean;
  include_ip_address?: boolean;
  shadow_opacity?: number;
  show_for_groups?: ('all' | 'selected_only' | 'except') | null;
  show_in_context?: ('proxies' | 'shares') | null;
  show_watermark?: boolean;
  text_appearance?: 'top' | 'center' | 'bottom';
  text_opacity?: number;
}
/**
 * Original schema `PasswordChecksTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-PasswordChecksTypeSchema}
 */
export interface SettingsPasswordChecksTypeSchema {
  digits?: number | null;
  lowercase?: number | null;
  max_length?: number | null;
  min_length?: number | null;
  special_symbols?: number | null;
  uppercase?: number | null;
}
/**
 * Original schema `SearchDisplayFieldSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-SearchDisplayFieldSchema}
 */
export interface SettingsSearchDisplayFieldSchema {
  name: string;
}
/**
 * Original schema `SortSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-SortSchema}
 */
export interface SettingsSortSchema {
  name: string;
  order?: 'asc' | 'desc';
}
/**
 * Original schema `SystemSettingPublicSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-SystemSettingPublicSchema}
 */
export interface SettingsSystemSettingPublicSchema {
  acl_template_id?: string | null;
  ai?: SettingsAIStateSchema;
  allow_invites_by_link?: boolean | null;
  allow_mobile_upload_without_required_metadata?: boolean | null;
  /**
   * Allow playing the original file while transcoding is in progress.
   */
  allow_play_original_during_transcoding?: boolean | null;
  allow_share_magic_link_creation?: boolean | null;
  /**
   * @minItems 0
   * @maxItems 100
   */
  allowed_ips?: SettingsAllowedIPSchema[];
  append_asset_uuid_to_downloads?: boolean | null;
  asset_default_sections?: string[];
  billing_tier?: string;
  client_ip?: string;
  collections_get_parent_acls?: boolean | null;
  cors_hosts?: string[];
  custom_terms?: boolean;
  /**
   * URL to a CuttingRoom tenant. (e.g https://tenant.region.cuttingroom.com)
   */
  cuttingroom_url?: string | null;
  date_format?: string | null;
  datetime_format?: string | null;
  /**
   * Default time to live for app tokens in seconds.
   */
  default_app_token_ttl?: number | null;
  /**
   * Default time to live for refresh tokens in seconds.
   */
  default_refresh_token_ttl?: number | null;
  default_share_options?: SettingsDefaultShareOptionsTypeSchema | null;
  default_upload_storage_id?: string | null;
  /**
   * Default time to live for user tokens in seconds.
   */
  default_user_token_ttl?: number | null;
  /**
   * Grace period that indicate how long objects will live in recycle bin. Unit: hours
   */
  delete_grace_period?: number | null;
  disable_billing_page?: boolean;
  domain_has_preloaded_assets?: boolean;
  /**
   * DRM setting
   */
  drm?: ('none' | 'standard') | null;
  /**
   * Whether to require hardware DRM for playback when DRM is enabled
   */
  drm_enforce?: boolean | null;
  /**
   * Master switch for AI features.
   */
  enable_ai?: boolean;
  enable_ai_metadata_filling?: boolean | null;
  enable_face_recognition?: boolean | null;
  enable_nltf?: boolean | null;
  enable_portals?: boolean | null;
  enable_shield?: boolean | null;
  /**
   * When enabled, magic links can only be sent to allowlisted emails/domains
   */
  enforce_magic_link_allowlist?: boolean | null;
  external_share?: boolean | null;
  external_share_options?: SettingsExternalShareOptionsTypeSchema | null;
  facet_fields?: SettingsFacetFieldSchema[];
  features?: string[];
  filters_default_metadata_view_id?: string | null;
  hide_favourites?: boolean | null;
  home_page?: string | null;
  image_properties_metadata_field?: string | null;
  is_plg_domain?: boolean;
  jobs_dashboard?: SettingsJobsDashboardSchema | null;
  locations_metadata_field?: string | null;
  /**
   * Forbid regular users to edit or delete mapped collections.
   */
  lock_mapped_collections?: boolean | null;
  logo_storage_id?: string | null;
  logo_url?: string;
  logos_metadata_field?: string | null;
  max_browse_users?: number | null;
  max_power_users?: number | null;
  max_standard_users?: number | null;
  max_storage_bytes?: number | null;
  max_traffic_bytes?: number | null;
  mfa_methods?: ('TOTP' | 'MAIL_2SV')[] | null;
  mfa_required?: boolean | null;
  password_checks?: SettingsPasswordChecksTypeSchema | null;
  require_limit_download_groups?: boolean | null;
  required_metadata_views?: string[];
  review_experience_disabled?: boolean | null;
  review_experience_disabled_per_share?: boolean | null;
  safe_searches_metadata_field?: string | null;
  saml_require_groups?: boolean | null;
  search_auto_resize_title_column?: boolean | null;
  search_default_sections?: string[];
  search_display_fields?: SettingsSearchDisplayFieldSchema[];
  search_in_transcriptions?: boolean | null;
  search_results_asset_metadata_view_id?: string | null;
  search_results_collection_metadata_view_id?: string | null;
  search_users_from_share?: boolean | null;
  search_view_id?: string | null;
  /**
   * Default share expiration time that indicate how long share will be valid. Unit: days
   */
  share_expiration_time?: number | null;
  support_access?: boolean | null;
  system_domain_id?: string;
  system_domain_name?: string;
  tags_metadata_field?: string | null;
  texts_metadata_field?: string | null;
  update_saml_primary_group_on_login?: boolean | null;
  use_asset_name_on_download?: boolean | null;
  /**
   * Watermark setting
   */
  watermark?: ('none' | 'standard') | null;
  watermark_options?: SettingsWatermarkOptionsType | null;
}
/**
 * Original schema `SystemSettingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-SystemSettingSchema}
 */
export interface SettingsSystemSettingSchema {
  acl_template_id?: string | null;
  ai?: SettingsAIStateSchema;
  allow_invites_by_link?: boolean | null;
  allow_mobile_upload_without_required_metadata?: boolean | null;
  /**
   * Allow playing the original file while transcoding is in progress.
   */
  allow_play_original_during_transcoding?: boolean | null;
  allow_share_magic_link_creation?: boolean | null;
  /**
   * @minItems 0
   * @maxItems 100
   */
  allowed_ips?: SettingsAllowedIPSchema[];
  append_asset_uuid_to_downloads?: boolean | null;
  asset_default_sections?: string[];
  client_ip?: string;
  collections_get_parent_acls?: boolean | null;
  cors_hosts?: string[];
  /**
   * URL to a CuttingRoom tenant. (e.g https://tenant.region.cuttingroom.com)
   */
  cuttingroom_url?: string | null;
  date_format?: string | null;
  datetime_format?: string | null;
  /**
   * Default time to live for app tokens in seconds.
   */
  default_app_token_ttl?: number | null;
  /**
   * Default time to live for refresh tokens in seconds.
   */
  default_refresh_token_ttl?: number | null;
  default_share_options?: SettingsDefaultShareOptionsTypeSchema | null;
  default_upload_storage_id?: string | null;
  /**
   * Default time to live for user tokens in seconds.
   */
  default_user_token_ttl?: number | null;
  /**
   * Grace period that indicate how long objects will live in recycle bin. Unit: hours
   */
  delete_grace_period?: number | null;
  /**
   * DRM setting
   */
  drm?: ('none' | 'standard') | null;
  /**
   * Whether to require hardware DRM for playback when DRM is enabled
   */
  drm_enforce?: boolean | null;
  /**
   * Master switch for AI features.
   */
  enable_ai?: boolean;
  enable_ai_metadata_filling?: boolean | null;
  enable_face_recognition?: boolean | null;
  enable_nltf?: boolean | null;
  enable_portals?: boolean | null;
  enable_shield?: boolean | null;
  /**
   * When enabled, magic links can only be sent to allowlisted emails/domains
   */
  enforce_magic_link_allowlist?: boolean | null;
  external_share?: boolean | null;
  external_share_options?: SettingsExternalShareOptionsTypeSchema | null;
  facet_fields?: SettingsFacetFieldSchema[];
  filters_default_metadata_view_id?: string | null;
  hide_favourites?: boolean | null;
  home_page?: string | null;
  image_properties_metadata_field?: string | null;
  jobs_dashboard?: SettingsJobsDashboardSchema | null;
  locations_metadata_field?: string | null;
  /**
   * Forbid regular users to edit or delete mapped collections.
   */
  lock_mapped_collections?: boolean | null;
  logo_storage_id?: string | null;
  logo_url?: string | null;
  logos_metadata_field?: string | null;
  max_browse_users?: number | null;
  max_power_users?: number | null;
  max_standard_users?: number | null;
  max_storage_bytes?: number | null;
  max_traffic_bytes?: number | null;
  mfa_methods?: ('TOTP' | 'MAIL_2SV')[] | null;
  mfa_required?: boolean | null;
  password_checks?: SettingsPasswordChecksTypeSchema | null;
  require_limit_download_groups?: boolean | null;
  required_metadata_views?: string[];
  review_experience_disabled?: boolean | null;
  review_experience_disabled_per_share?: boolean | null;
  safe_searches_metadata_field?: string | null;
  saml_require_groups?: boolean | null;
  search_auto_resize_title_column?: boolean | null;
  search_default_sections?: string[];
  search_display_fields?: SettingsSearchDisplayFieldSchema[];
  search_in_transcriptions?: boolean | null;
  search_results_asset_metadata_view_id?: string | null;
  search_results_collection_metadata_view_id?: string | null;
  search_users_from_share?: boolean | null;
  /**
   * Default share expiration time that indicate how long share will be valid. Unit: days
   */
  share_expiration_time?: number | null;
  support_access?: boolean | null;
  system_domain_id?: string;
  system_domain_name?: string;
  tags_metadata_field?: string | null;
  texts_metadata_field?: string | null;
  update_saml_primary_group_on_login?: boolean | null;
  use_asset_name_on_download?: boolean | null;
  /**
   * Watermark setting
   */
  watermark?: ('none' | 'standard') | null;
  watermark_options?: SettingsWatermarkOptionsType | null;
}
/**
 * Original schema `ThemeBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemeBaseSchema}
 */
export interface SettingsThemeBaseSchema {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id?: string;
  name: string;
  system_domain_id?: string;
  theme_data: SettingsThemeData;
}
/**
 * Original schema `ThemeData`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemeData}
 */
export interface SettingsThemeData {
  base?: ('light' | 'dark') | null;
  colors?: SettingsThemeColors | null;
  typography?: SettingsThemeTypography | null;
}
/**
 * Original schema `ThemeColors`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemeColors}
 */
export interface SettingsThemeColors {
  background?: string | null;
  primary?: string | null;
  secondary?: string | null;
  text?: string | null;
}
/**
 * Original schema `ThemeTypography`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemeTypography}
 */
export interface SettingsThemeTypography {
  font_family?: string | null;
  font_size_base?: string | null;
  heading_font_family?: string | null;
}
/**
 * Original schema `ThemeColorsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemeColorsSchema}
 */
export interface SettingsThemeColorsSchema {
  background?: string | null;
  primary?: string | null;
  secondary?: string | null;
  text?: string | null;
}
/**
 * Original schema `ThemeCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemeCreateSchema}
 */
export interface SettingsThemeCreateSchema {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id?: string;
  name: string;
  system_domain_id?: string;
  theme_data: SettingsThemeData;
}
/**
 * Original schema `ThemeDataSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemeDataSchema}
 */
export interface SettingsThemeDataSchema {
  base?: ('light' | 'dark') | null;
  colors?: SettingsThemeColorsSchema | null;
  typography?: SettingsThemeTypography | null;
}
/**
 * Original schema `ThemeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemeSchema}
 */
export interface SettingsThemeSchema {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id?: string;
  name: string;
  system_domain_id?: string;
  theme_data: SettingsThemeDataSchema;
}
/**
 * Original schema `ThemeTypographySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemeTypographySchema}
 */
export interface SettingsThemeTypographySchema {
  font_family?: string | null;
  font_size_base?: string | null;
  heading_font_family?: string | null;
}
/**
 * Original schema `ThemesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemesSchema}
 */
export interface SettingsThemesSchema {
  objects?: SettingsThemeSchema[];
}
/**
 * Original schema `UsageHistorySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-UsageHistorySchema}
 */
export interface SettingsUsageHistorySchema {
  widgets?: SettingsUsageHistoryWidget[];
}
/**
 * Original schema `UsageHistoryWidgetSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-UsageHistoryWidgetSchema}
 */
export interface SettingsUsageHistoryWidgetSchema {
  expanded?: boolean;
  id?: string;
}
/**
 * Original schema `UserSettingRemoveAttributesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-UserSettingRemoveAttributesSchema}
 */
export interface SettingsUserSettingRemoveAttributesSchema {
  /**
   * @minItems 0
   * @maxItems 100
   */
  allowed_ips?: SettingsAllowedIPSchema[];
  asset_default_sections?: string[];
  facet_fields?: SettingsFacetFieldSchema[];
  jobs_dashboard?: SettingsJobsDashboardSchema | null;
  search_default_sections?: string[];
  search_display_fields?: SettingsSearchDisplayFieldSchema[];
  user_ids: string[];
}
/**
 * Original schema `UserSettingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-UserSettingSchema}
 */
export interface SettingsUserSettingSchema {
  acl_template_id?: string | null;
  /**
   * @minItems 0
   * @maxItems 100
   */
  allowed_ips?: SettingsAllowedIPSchema[];
  append_asset_uuid_to_downloads?: boolean | null;
  asset_default_sections?: string[];
  client_ip?: string;
  collections_get_parent_acls?: boolean | null;
  dashboard?: SettingsDashboardSchema | null;
  date_format?: string | null;
  datetime_format?: string | null;
  default_upload_storage_id?: string | null;
  /**
   * Grace period that indicate how long objects will live in recycle bin. Unit: hours
   */
  delete_grace_period?: number | null;
  facet_fields?: SettingsFacetFieldSchema[];
  filters_default_metadata_view_id?: string | null;
  genesis?: string | null;
  hide_favourites?: boolean | null;
  home_page?: string | null;
  jobs_dashboard?: SettingsJobsDashboardSchema | null;
  search_auto_resize_title_column?: boolean | null;
  search_default_sections?: string[];
  search_display_fields?: SettingsSearchDisplayFieldSchema[];
  search_in_transcriptions?: boolean | null;
  search_results_asset_metadata_view_id?: string | null;
  search_results_collection_metadata_view_id?: string | null;
  search_view_id?: string | null;
  /**
   * Default share expiration time that indicate how long share will be valid. Unit: days
   */
  share_expiration_time?: number | null;
  show_persons_confirmation_modal?: boolean | null;
  usage_history?: SettingsUsageHistorySchema | null;
  use_asset_name_on_download?: boolean | null;
}
/**
 * Original schema `WatermarkOptionsTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-WatermarkOptionsTypeSchema}
 */
export interface SettingsWatermarkOptionsTypeSchema {
  custom_text?: string;
  groups?: string[] | null;
  include_custom_text?: boolean;
  include_date_time?: boolean;
  include_email?: boolean;
  include_ip_address?: boolean;
  shadow_opacity?: number;
  show_for_groups?: ('all' | 'selected_only' | 'except') | null;
  show_in_context?: ('proxies' | 'shares') | null;
  show_watermark?: boolean;
  text_appearance?: 'top' | 'center' | 'bottom';
  text_opacity?: number;
}
/**
 * Original schema `AIConsentEventsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentEventsSchema}
 */
export interface SettingsAIConsentEventsSchemaWithId {
  objects: SettingsAIConsentEventSchemaWithIdNullable[];
}
/**
 * Original schema `AIConsentEventSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentEventSchema}
 */
export interface SettingsAIConsentEventSchemaWithIdNullable {
  acting_as_user_id?: string | null;
  action?:
    | (
        | 'ACCEPTED'
        | 'DECLINED'
        | 'REVOKED'
        | 'REVOKED_BY_MASTER_SWITCH'
        | 'LEGACY_IMPORTED'
        | 'NOTICE_ELAPSED'
      )
    | null;
  app_id?: string | null;
  date_created?: string | null;
  document_id?: string | null;
  document_url?: string | null;
  document_version?: string | null;
  evidence?: string | null;
  id: string;
  ip?: string | null;
  origin?: string | null;
  user_email?: string | null;
  user_id?: string | null;
}
/**
 * Original schema `AIConsentEventSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentEventSchema}
 */
export interface SettingsAIConsentEventSchemaWithId {
  acting_as_user_id?: string | null;
  action?:
    | 'ACCEPTED'
    | 'DECLINED'
    | 'REVOKED'
    | 'REVOKED_BY_MASTER_SWITCH'
    | 'LEGACY_IMPORTED'
    | 'NOTICE_ELAPSED';
  app_id?: string | null;
  date_created?: string;
  document_id?: string | null;
  document_url?: string | null;
  document_version?: string | null;
  evidence?: string | null;
  id: string;
  ip?: string | null;
  origin?: string | null;
  user_email?: string | null;
  user_id?: string | null;
}
/**
 * Original schema `AIConsentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentsSchema}
 */
export interface SettingsAIConsentsSchemaWithId {
  objects: SettingsAIConsentSchemaNullable[];
}
/**
 * Original schema `AIConsentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentSchema}
 */
export interface SettingsAIConsentSchemaNullable {
  date_created?: string | null;
  date_revoked?: string | null;
  document_id?: string | null;
  document_url?: string | null;
  evidence?: string | null;
  origin?:
    | (
        | 'ADMIN_ACCEPTED'
        | 'LEGACY_UI_CONSENT'
        | 'LEGACY_BETA_AGREEMENT'
        | 'NOTICE_ELAPSED'
      )
    | null;
  status?: ('GRANTED' | 'REVOKED' | 'DECLINED') | null;
  version?: string | null;
}
/**
 * Original schema `AIConsentDocumentsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentDocumentsSchema}
 */
export interface SettingsAIConsentDocumentsSchemaWithId {
  objects: SettingsAIConsentDocumentSchemaWithIdNullable[];
}
/**
 * Original schema `AIConsentDocumentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentDocumentSchema}
 */
export interface SettingsAIConsentDocumentSchemaWithIdNullable {
  id: string;
  /**
   * ISO 8601 date this version was published.
   */
  published_at?: string | null;
  title?: string | null;
  url?: string | null;
  version?: string | null;
}
/**
 * Original schema `AIConsentDocumentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-AIConsentDocumentSchema}
 */
export interface SettingsAIConsentDocumentSchemaWithId {
  id: string;
  /**
   * ISO 8601 date this version was published.
   */
  published_at?: string | null;
  title?: string;
  url?: string;
  version?: string;
}
/**
 * Original schema `CORSHostsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-CORSHostsSchema}
 */
export interface SettingsCORSHostsSchemaWithId {
  objects: SettingsCORSHostSchemaWithId[];
}
/**
 * Original schema `CORSHostSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-CORSHostSchema}
 */
export interface SettingsCORSHostSchemaWithId {
  host: string;
  id: string;
}
/**
 * Original schema `GroupSettingPublicSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-GroupSettingPublicSchema}
 */
export interface SettingsGroupSettingPublicSchemaNullable {
  acl_template_id?: string | null;
  allowed_ips?: SettingsAllowedIPSchema[] | null;
  append_asset_uuid_to_downloads?: boolean | null;
  asset_default_sections?: string[] | null;
  client_ip?: string | null;
  collections_get_parent_acls?: boolean | null;
  date_format?: string | null;
  datetime_format?: string | null;
  default_upload_storage_id?: string | null;
  /**
   * Grace period that indicate how long objects will live in recycle bin. Unit: hours
   */
  delete_grace_period?: number | null;
  facet_fields?: SettingsFacetFieldSchema[] | null;
  filters_default_metadata_view_id?: string | null;
  group_id?: string | null;
  hide_favourites?: boolean | null;
  home_page?: string | null;
  jobs_dashboard?: SettingsJobsDashboard | null;
  logo_storage_id?: string | null;
  logo_url?: string | null;
  required_metadata_views?: string[] | null;
  search_auto_resize_title_column?: boolean | null;
  search_default_sections?: string[] | null;
  search_display_fields?: SettingsSearchDisplayField[] | null;
  search_in_transcriptions?: boolean | null;
  search_results_asset_metadata_view_id?: string | null;
  search_results_collection_metadata_view_id?: string | null;
  search_view_id?: string | null;
  /**
   * Default share expiration time that indicate how long share will be valid. Unit: days
   */
  share_expiration_time?: number | null;
  system_domain_id?: string | null;
  use_asset_name_on_download?: boolean | null;
}
/**
 * Original schema `MergedSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-MergedSettingsSchema}
 */
export interface SettingsMergedSettingsSchemaNullable {
  acl_template_id?: string | null;
  ai?: SettingsAIStateSchema | null;
  allow_invites_by_link?: boolean | null;
  allow_mobile_upload_without_required_metadata?: boolean | null;
  /**
   * Allow playing the original file while transcoding is in progress.
   */
  allow_play_original_during_transcoding?: boolean | null;
  allow_share_magic_link_creation?: boolean | null;
  allowed_ips?: SettingsAllowedIPSchema[] | null;
  append_asset_uuid_to_downloads?: boolean | null;
  asset_default_sections?: string[] | null;
  billing_tier?: string | null;
  client_ip?: string | null;
  collections_get_parent_acls?: boolean | null;
  cors_hosts?: string[] | null;
  custom_terms?: boolean | null;
  /**
   * URL to a CuttingRoom tenant. (e.g https://tenant.region.cuttingroom.com)
   */
  cuttingroom_url?: string | null;
  dashboard?: SettingsDashboardSchema | null;
  date_format?: string | null;
  datetime_format?: string | null;
  /**
   * Default time to live for app tokens in seconds.
   */
  default_app_token_ttl?: number | null;
  /**
   * Default time to live for refresh tokens in seconds.
   */
  default_refresh_token_ttl?: number | null;
  default_share_options?: SettingsDefaultShareOptionsTypeSchema | null;
  default_upload_storage_id?: string | null;
  /**
   * Default time to live for user tokens in seconds.
   */
  default_user_token_ttl?: number | null;
  /**
   * Grace period that indicate how long objects will live in recycle bin. Unit: hours
   */
  delete_grace_period?: number | null;
  disable_billing_page?: boolean | null;
  domain_has_preloaded_assets?: boolean | null;
  /**
   * DRM setting
   */
  drm?: ('none' | 'standard') | null;
  /**
   * Whether to require hardware DRM for playback when DRM is enabled
   */
  drm_enforce?: boolean | null;
  /**
   * Master switch for AI features.
   */
  enable_ai?: boolean | null;
  enable_ai_metadata_filling?: boolean | null;
  enable_face_recognition?: boolean | null;
  enable_nltf?: boolean | null;
  enable_portals?: boolean | null;
  enable_shield?: boolean | null;
  /**
   * When enabled, magic links can only be sent to allowlisted emails/domains
   */
  enforce_magic_link_allowlist?: boolean | null;
  external_share?: boolean | null;
  external_share_options?: SettingsExternalShareOptionsTypeSchema | null;
  facet_fields?: SettingsFacetFieldSchema[] | null;
  features?: string[] | null;
  filters_default_metadata_view_id?: string | null;
  genesis?: string | null;
  group_id?: string | null;
  hide_favourites?: boolean | null;
  home_page?: string | null;
  image_properties_metadata_field?: string | null;
  is_plg_domain?: boolean | null;
  jobs_dashboard?: SettingsJobsDashboardSchema | null;
  locations_metadata_field?: string | null;
  /**
   * Forbid regular users to edit or delete mapped collections.
   */
  lock_mapped_collections?: boolean | null;
  logo_storage_id?: string | null;
  logo_url?: string | null;
  logos_metadata_field?: string | null;
  max_browse_users?: number | null;
  max_power_users?: number | null;
  max_standard_users?: number | null;
  max_storage_bytes?: number | null;
  max_traffic_bytes?: number | null;
  mfa_methods?: ('TOTP' | 'MAIL_2SV')[] | null;
  mfa_required?: boolean | null;
  password_checks?: SettingsPasswordChecksType | null;
  require_limit_download_groups?: boolean | null;
  required_metadata_views?: string[] | null;
  review_experience_disabled?: boolean | null;
  review_experience_disabled_per_share?: boolean | null;
  safe_searches_metadata_field?: string | null;
  saml_require_groups?: boolean | null;
  search_auto_resize_title_column?: boolean | null;
  search_default_sections?: string[] | null;
  search_display_fields?: SettingsSearchDisplayField[] | null;
  search_in_transcriptions?: boolean | null;
  search_results_asset_metadata_view_id?: string | null;
  search_results_collection_metadata_view_id?: string | null;
  search_users_from_share?: boolean | null;
  search_view_id?: string | null;
  /**
   * Default share expiration time that indicate how long share will be valid. Unit: days
   */
  share_expiration_time?: number | null;
  show_persons_confirmation_modal?: boolean | null;
  support_access?: boolean | null;
  system_domain_id?: string | null;
  system_domain_name?: string | null;
  tags_metadata_field?: string | null;
  texts_metadata_field?: string | null;
  update_saml_primary_group_on_login?: boolean | null;
  usage_history?: SettingsUsageHistory | null;
  use_asset_name_on_download?: boolean | null;
  /**
   * Watermark setting
   */
  watermark?: ('none' | 'standard') | null;
  watermark_options?: SettingsWatermarkOptionsType | null;
}
/**
 * Original schema `SystemSettingPublicSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-SystemSettingPublicSchema}
 */
export interface SettingsSystemSettingPublicSchemaNullable {
  acl_template_id?: string | null;
  ai?: SettingsAIStateSchema | null;
  allow_invites_by_link?: boolean | null;
  allow_mobile_upload_without_required_metadata?: boolean | null;
  /**
   * Allow playing the original file while transcoding is in progress.
   */
  allow_play_original_during_transcoding?: boolean | null;
  allow_share_magic_link_creation?: boolean | null;
  allowed_ips?: SettingsAllowedIPSchema[] | null;
  append_asset_uuid_to_downloads?: boolean | null;
  asset_default_sections?: string[] | null;
  billing_tier?: string | null;
  client_ip?: string | null;
  collections_get_parent_acls?: boolean | null;
  cors_hosts?: string[] | null;
  custom_terms?: boolean | null;
  /**
   * URL to a CuttingRoom tenant. (e.g https://tenant.region.cuttingroom.com)
   */
  cuttingroom_url?: string | null;
  date_format?: string | null;
  datetime_format?: string | null;
  /**
   * Default time to live for app tokens in seconds.
   */
  default_app_token_ttl?: number | null;
  /**
   * Default time to live for refresh tokens in seconds.
   */
  default_refresh_token_ttl?: number | null;
  default_share_options?: SettingsDefaultShareOptionsTypeSchema | null;
  default_upload_storage_id?: string | null;
  /**
   * Default time to live for user tokens in seconds.
   */
  default_user_token_ttl?: number | null;
  /**
   * Grace period that indicate how long objects will live in recycle bin. Unit: hours
   */
  delete_grace_period?: number | null;
  disable_billing_page?: boolean | null;
  domain_has_preloaded_assets?: boolean | null;
  /**
   * DRM setting
   */
  drm?: ('none' | 'standard') | null;
  /**
   * Whether to require hardware DRM for playback when DRM is enabled
   */
  drm_enforce?: boolean | null;
  /**
   * Master switch for AI features.
   */
  enable_ai?: boolean | null;
  enable_ai_metadata_filling?: boolean | null;
  enable_face_recognition?: boolean | null;
  enable_nltf?: boolean | null;
  enable_portals?: boolean | null;
  enable_shield?: boolean | null;
  /**
   * When enabled, magic links can only be sent to allowlisted emails/domains
   */
  enforce_magic_link_allowlist?: boolean | null;
  external_share?: boolean | null;
  external_share_options?: SettingsExternalShareOptionsTypeSchema | null;
  facet_fields?: SettingsFacetFieldSchema[] | null;
  features?: string[] | null;
  filters_default_metadata_view_id?: string | null;
  hide_favourites?: boolean | null;
  home_page?: string | null;
  image_properties_metadata_field?: string | null;
  is_plg_domain?: boolean | null;
  jobs_dashboard?: SettingsJobsDashboardSchema | null;
  locations_metadata_field?: string | null;
  /**
   * Forbid regular users to edit or delete mapped collections.
   */
  lock_mapped_collections?: boolean | null;
  logo_storage_id?: string | null;
  logo_url?: string | null;
  logos_metadata_field?: string | null;
  max_browse_users?: number | null;
  max_power_users?: number | null;
  max_standard_users?: number | null;
  max_storage_bytes?: number | null;
  max_traffic_bytes?: number | null;
  mfa_methods?: ('TOTP' | 'MAIL_2SV')[] | null;
  mfa_required?: boolean | null;
  password_checks?: SettingsPasswordChecksTypeSchema | null;
  require_limit_download_groups?: boolean | null;
  required_metadata_views?: string[] | null;
  review_experience_disabled?: boolean | null;
  review_experience_disabled_per_share?: boolean | null;
  safe_searches_metadata_field?: string | null;
  saml_require_groups?: boolean | null;
  search_auto_resize_title_column?: boolean | null;
  search_default_sections?: string[] | null;
  search_display_fields?: SettingsSearchDisplayFieldSchema[] | null;
  search_in_transcriptions?: boolean | null;
  search_results_asset_metadata_view_id?: string | null;
  search_results_collection_metadata_view_id?: string | null;
  search_users_from_share?: boolean | null;
  search_view_id?: string | null;
  /**
   * Default share expiration time that indicate how long share will be valid. Unit: days
   */
  share_expiration_time?: number | null;
  support_access?: boolean | null;
  system_domain_id?: string | null;
  system_domain_name?: string | null;
  tags_metadata_field?: string | null;
  texts_metadata_field?: string | null;
  update_saml_primary_group_on_login?: boolean | null;
  use_asset_name_on_download?: boolean | null;
  /**
   * Watermark setting
   */
  watermark?: ('none' | 'standard') | null;
  watermark_options?: SettingsWatermarkOptionsType | null;
}
/**
 * Original schema `ThemesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemesSchema}
 */
export interface SettingsThemesSchemaWithId {
  objects: SettingsThemeSchemaWithIdNullable[];
}
/**
 * Original schema `ThemeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemeSchema}
 */
export interface SettingsThemeSchemaWithIdNullable {
  created_by_user?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  id: string;
  name: string;
  system_domain_id?: string | null;
  theme_data: SettingsThemeDataSchema;
}
/**
 * Original schema `ThemeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-ThemeSchema}
 */
export interface SettingsThemeSchemaWithId {
  created_by_user?: string;
  date_created?: string;
  date_modified?: string;
  id: string;
  name: string;
  system_domain_id?: string;
  theme_data: SettingsThemeDataSchema;
}
/**
 * Original schema `UserSettingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#model-UserSettingSchema}
 */
export interface SettingsUserSettingSchemaNullable {
  acl_template_id?: string | null;
  allowed_ips?: SettingsAllowedIPSchema[] | null;
  append_asset_uuid_to_downloads?: boolean | null;
  asset_default_sections?: string[] | null;
  client_ip?: string | null;
  collections_get_parent_acls?: boolean | null;
  dashboard?: SettingsDashboardSchema | null;
  date_format?: string | null;
  datetime_format?: string | null;
  default_upload_storage_id?: string | null;
  /**
   * Grace period that indicate how long objects will live in recycle bin. Unit: hours
   */
  delete_grace_period?: number | null;
  facet_fields?: SettingsFacetFieldSchema[] | null;
  filters_default_metadata_view_id?: string | null;
  genesis?: string | null;
  hide_favourites?: boolean | null;
  home_page?: string | null;
  jobs_dashboard?: SettingsJobsDashboardSchema | null;
  search_auto_resize_title_column?: boolean | null;
  search_default_sections?: string[] | null;
  search_display_fields?: SettingsSearchDisplayFieldSchema[] | null;
  search_in_transcriptions?: boolean | null;
  search_results_asset_metadata_view_id?: string | null;
  search_results_collection_metadata_view_id?: string | null;
  search_view_id?: string | null;
  /**
   * Default share expiration time that indicate how long share will be valid. Unit: days
   */
  share_expiration_time?: number | null;
  show_persons_confirmation_modal?: boolean | null;
  usage_history?: SettingsUsageHistorySchema | null;
  use_asset_name_on_download?: boolean | null;
}

export interface SettingsHttpGetAiConsentEventsQuery {
  per_page?: number;
}

/**
 * `GET /v1/ai/consent_events/`
 *
 * Audit trail of the consent acceptances and revocations of the system domain
 *
 *
 * Responses
 * - 200 - Returns the consent events, most recent first
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Restricted access
 *
 * Response {@link SettingsAIConsentEventsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_ai_consent_events_}
 */
export const httpGetAiConsentEvents = (
  query?: SettingsHttpGetAiConsentEventsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpGetAiConsentEvents,
  method: httpMethod.get,
  url: '/API/settings/v1/ai/consent_events/',

  query,
  headers,
});

/**
 * `GET /v1/ai/consents/`
 *
 * Consent state of the current system domain, one entry per clause
 *
 *
 * Responses
 * - 200 - Returns the consents of the system domain
 * - 401 - Token is invalid
 *
 * Response {@link SettingsAIConsentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_ai_consents_}
 */
export const httpGetAiConsents = (headers?: IconikApiHeaders) => ({
  id: SettingsHttpGetAiConsents,
  method: httpMethod.get,
  url: '/API/settings/v1/ai/consents/',

  headers,
});

/**
 * `POST /v1/ai/consents/`
 *
 * Accept a batch of consent documents
 *
 *
 * Responses
 * - 200 - Returns the consents of the system domain after acceptance
 * - 400 - Bad request, or unknown document
 * - 401 - Token is invalid
 * - 403 - Restricted access
 * - 409 - A referenced document is no longer the version in force
 *
 * Response {@link SettingsAIConsentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/post_v1_ai_consents_}
 */
export const httpPostAiConsents = (
  body: SettingsAIConsentAcceptSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPostAiConsents,
  method: httpMethod.post,
  url: '/API/settings/v1/ai/consents/',

  body,
  headers,
});

/**
 * `POST /v1/ai/consents/decline/`
 *
 * Refuse consent documents, so they cannot take effect by non-objection
 *
 *
 * Responses
 * - 200 - Returns the consents of the system domain after the refusal
 * - 400 - Bad request, or unknown document
 * - 401 - Token is invalid
 * - 403 - Restricted access
 * - 409 - A referenced document is no longer the version in force
 *
 * Response {@link SettingsAIConsentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/post_v1_ai_consents_decline_}
 */
export const httpPostAiConsentsDecline = (
  body: SettingsAIConsentDeclineRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPostAiConsentsDecline,
  method: httpMethod.post,
  url: '/API/settings/v1/ai/consents/decline/',

  body,
  headers,
});

/**
 * `POST /v1/ai/consents/revoke/`
 *
 * Withdraw the acceptance of consent documents
 *
 *
 * Responses
 * - 200 - Returns the positions of the domain after the withdrawal
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Restricted access
 *
 * Response {@link SettingsAIConsentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/post_v1_ai_consents_revoke_}
 */
export const httpPostAiConsentsRevoke = (
  body: SettingsAIConsentRevokeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPostAiConsentsRevoke,
  method: httpMethod.post,
  url: '/API/settings/v1/ai/consents/revoke/',

  body,
  headers,
});

/**
 * `GET /v1/ai/documents/`
 *
 * List the consent documents a customer may be asked to accept
 *
 *
 * Responses
 * - 200 - Returns the consent documents catalog
 * - 401 - Token is invalid
 *
 * Response {@link SettingsAIConsentDocumentsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_ai_documents_}
 */
export const httpGetAiDocuments = (headers?: IconikApiHeaders) => ({
  id: SettingsHttpGetAiDocuments,
  method: httpMethod.get,
  url: '/API/settings/v1/ai/documents/',

  headers,
});

/**
 * `GET /v1/cors_hosts/`
 *
 * List of CORS hosts
 *
 * Required roles:
 *  - can_read_cors_hosts
 *
 * Responses
 * - 200 - Returns a system settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Realm does not exist
 *
 * Response {@link SettingsCORSHostsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_cors_hosts_}
 */
export const httpGetCorsHosts = (headers?: IconikApiHeaders) => ({
  id: SettingsHttpGetCorsHosts,
  method: httpMethod.get,
  url: '/API/settings/v1/cors_hosts/',

  headers,
});

/**
 * `POST /v1/cors_hosts/`
 *
 * Create a new CORS host
 *
 * Required roles:
 *  - can_write_cors_hosts
 *
 * Responses
 * - 201 - Returns a created CORS host
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SettingsCORSHostSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/post_v1_cors_hosts_}
 */
export const httpPostCorsHosts = (
  body: SettingsCORSHostSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPostCorsHosts,
  method: httpMethod.post,
  url: '/API/settings/v1/cors_hosts/',

  body,
  headers,
});

/**
 * `DELETE /v1/cors_hosts/{cors_host_id}/`
 *
 * Delete a particular CORS host by id
 *
 * Required roles:
 *  - can_delete_cors_hosts
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/delete_v1_cors_hosts__cors_host_id__}
 */
export const httpDeleteCorsHostsByCorsHostId = (
  corsHostId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpDeleteCorsHostsByCorsHostId,
  method: httpMethod.delete,
  url: `/API/settings/v1/cors_hosts/${encodeURIComponent(corsHostId)}/`,
  params: { corsHostId },
  headers,
});

/**
 * `GET /v1/cors_hosts/{cors_host_id}/`
 *
 * Returns a particular CORS host by id
 *
 * Required roles:
 *  - can_read_cors_hosts
 *
 * Responses
 * - 200 - Returns a CORS host
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - CORS host does not exist
 *
 * Response {@link SettingsCORSHostSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_cors_hosts__cors_host_id__}
 */
export const httpGetCorsHostsByCorsHostId = (
  corsHostId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpGetCorsHostsByCorsHostId,
  method: httpMethod.get,
  url: `/API/settings/v1/cors_hosts/${encodeURIComponent(corsHostId)}/`,
  params: { corsHostId },
  headers,
});

/**
 * `DELETE /v1/group/{group_id}/`
 *
 * Delete group settings
 *
 * Required roles:
 *  - can_write_groups
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/delete_v1_group__group_id__}
 */
export const httpDeleteGroupByGroupId = (
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpDeleteGroupByGroupId,
  method: httpMethod.delete,
  url: `/API/settings/v1/group/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  headers,
});

/**
 * `GET /v1/group/{group_id}/`
 *
 * Group settings
 *
 *
 * Responses
 * - 200 - Returns group settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Realm does not exist
 *
 * Response {@link SettingsGroupSettingPublicSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_group__group_id__}
 */
export const httpGetGroupByGroupId = (
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpGetGroupByGroupId,
  method: httpMethod.get,
  url: `/API/settings/v1/group/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  headers,
});

export type SettingsGroupSettingPublicSchemaPartial =
  Partial<SettingsGroupSettingPublicSchema>;

/**
 * `PATCH /v1/group/{group_id}/`
 *
 * Change group settings
 *
 * Required roles:
 *  - can_write_groups
 *
 * Responses
 * - 200 - Returns changed group settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Restricted access, or share_expiration_time cannot be changed
 *
 * Response {@link SettingsGroupSettingPublicSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/patch_v1_group__group_id__}
 */
export const httpPatchGroupByGroupId = (
  groupId: string,
  body: SettingsGroupSettingPublicSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPatchGroupByGroupId,
  method: httpMethod.patch,
  url: `/API/settings/v1/group/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  body,
  headers,
});

/**
 * `PUT /v1/group/{group_id}/`
 *
 * Change group settings
 *
 * Required roles:
 *  - can_write_groups
 *
 * Responses
 * - 200 - Returns changed group settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Restricted access, or share_expiration_time cannot be changed
 *
 * Response {@link SettingsGroupSettingPublicSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/put_v1_group__group_id__}
 */
export const httpPutGroupByGroupId = (
  groupId: string,
  body: SettingsGroupSettingPublicSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPutGroupByGroupId,
  method: httpMethod.put,
  url: `/API/settings/v1/group/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  body,
  headers,
});

export interface SettingsHttpGetMergedCurrentQuery {
  ignore_logo_url?: boolean;
}

/**
 * `GET /v1/merged/current/`
 *
 * Get merged settings for current user
 *
 *
 * Responses
 * - 200 - Returns a merged settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Realm does not exist
 *
 * Response {@link SettingsMergedSettingsSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_merged_current_}
 */
export const httpGetMergedCurrent = (
  query?: SettingsHttpGetMergedCurrentQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpGetMergedCurrent,
  method: httpMethod.get,
  url: '/API/settings/v1/merged/current/',

  query,
  headers,
});

export interface SettingsHttpGetMergedByUserIdQuery {
  ignore_logo_url?: boolean;
}

/**
 * `GET /v1/merged/{user_id}/`
 *
 * Get merged settings for a specific user
 *
 *
 * Responses
 * - 200 - Returns a merged settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Realm does not exist
 *
 * Response {@link SettingsMergedSettingsSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_merged__user_id__}
 */
export const httpGetMergedByUserId = (
  userId: string,
  query?: SettingsHttpGetMergedByUserIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpGetMergedByUserId,
  method: httpMethod.get,
  url: `/API/settings/v1/merged/${encodeURIComponent(userId)}/`,
  params: { userId },
  query,
  headers,
});

/**
 * `DELETE /v1/search_view/{view_id}/group_ids/`
 *
 * Remove the Search View ID from any Group ID in the list.
 *
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/delete_v1_search_view__view_id__group_ids_}
 */
export const httpDeleteSearchViewByViewIdGroupIds = (
  viewId: string,
  body: SettingsGroupSettingsIDSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpDeleteSearchViewByViewIdGroupIds,
  method: httpMethod.delete,
  url: `/API/settings/v1/search_view/${encodeURIComponent(viewId)}/group_ids/`,
  params: { viewId },
  body,
  headers,
});

/**
 * `GET /v1/search_view/{view_id}/group_ids/`
 *
 * Get a list of Group IDs that use the given Search View ID
 *
 *
 * Responses
 * - 200 - Returns group IDs
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SettingsGroupSettingsIDSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_search_view__view_id__group_ids_}
 */
export const httpGetSearchViewByViewIdGroupIds = (
  viewId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpGetSearchViewByViewIdGroupIds,
  method: httpMethod.get,
  url: `/API/settings/v1/search_view/${encodeURIComponent(viewId)}/group_ids/`,
  params: { viewId },
  headers,
});

export type SettingsGroupSettingsIDSchemaPartial =
  Partial<SettingsGroupSettingsIDSchema>;

/**
 * `PATCH /v1/search_view/{view_id}/group_ids/`
 *
 * Update the Search View ID for each Group Settings object that
 *
 * matches the Group IDs in the request body.
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/patch_v1_search_view__view_id__group_ids_}
 */
export const httpPatchSearchViewByViewIdGroupIds = (
  viewId: string,
  body: SettingsGroupSettingsIDSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPatchSearchViewByViewIdGroupIds,
  method: httpMethod.patch,
  url: `/API/settings/v1/search_view/${encodeURIComponent(viewId)}/group_ids/`,
  params: { viewId },
  body,
  headers,
});

/**
 * `PUT /v1/search_view/{view_id}/group_ids/`
 *
 * Set the Search View ID for each Group Settings object that
 *
 * matches the Group IDs in the request body.<br/>Remove the Search View ID from any Group ID not in the list.
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/put_v1_search_view__view_id__group_ids_}
 */
export const httpPutSearchViewByViewIdGroupIds = (
  viewId: string,
  body: SettingsGroupSettingsIDSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPutSearchViewByViewIdGroupIds,
  method: httpMethod.put,
  url: `/API/settings/v1/search_view/${encodeURIComponent(viewId)}/group_ids/`,
  params: { viewId },
  body,
  headers,
});

export interface SettingsHttpGetSystemCurrentQuery {
  ignore_logo_url?: boolean;
}

/**
 * `GET /v1/system/current/`
 *
 * System settings
 *
 *
 * Responses
 * - 200 - Returns a system settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Realm does not exist
 *
 * Response {@link SettingsSystemSettingPublicSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_system_current_}
 */
export const httpGetSystemCurrent = (
  query?: SettingsHttpGetSystemCurrentQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpGetSystemCurrent,
  method: httpMethod.get,
  url: '/API/settings/v1/system/current/',

  query,
  headers,
});

export type SettingsSystemSettingPublicSchemaPartial =
  Partial<SettingsSystemSettingPublicSchema>;

/**
 * `PATCH /v1/system/current/`
 *
 * Change system settings
 *
 *
 * Responses
 * - 200 - Returns changed system settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SettingsSystemSettingPublicSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/patch_v1_system_current_}
 */
export const httpPatchSystemCurrent = (
  body: SettingsSystemSettingPublicSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPatchSystemCurrent,
  method: httpMethod.patch,
  url: '/API/settings/v1/system/current/',

  body,
  headers,
});

/**
 * `PUT /v1/system/current/`
 *
 * Change system settings
 *
 *
 * Responses
 * - 200 - Returns changed system settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SettingsSystemSettingPublicSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/put_v1_system_current_}
 */
export const httpPutSystemCurrent = (
  body: SettingsSystemSettingPublicSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPutSystemCurrent,
  method: httpMethod.put,
  url: '/API/settings/v1/system/current/',

  body,
  headers,
});

export interface SettingsHttpGetSystemBySystemDomainIdQuery {
  ignore_logo_url?: boolean;
}

/**
 * `GET /v1/system/{system_domain_id}/`
 *
 * System settings
 *
 *
 * Responses
 * - 200 - Returns a system settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Realm does not exist
 *
 * Response {@link SettingsSystemSettingPublicSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_system__system_domain_id__}
 */
export const httpGetSystemBySystemDomainId = (
  systemDomainId: string,
  query?: SettingsHttpGetSystemBySystemDomainIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpGetSystemBySystemDomainId,
  method: httpMethod.get,
  url: `/API/settings/v1/system/${encodeURIComponent(systemDomainId)}/`,
  params: { systemDomainId },
  query,
  headers,
});

/**
 * `PATCH /v1/system/{system_domain_id}/`
 *
 * Change system settings
 *
 *
 * Responses
 * - 200 - Returns changed system settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SettingsSystemSettingPublicSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/patch_v1_system__system_domain_id__}
 */
export const httpPatchSystemBySystemDomainId = (
  systemDomainId: string,
  body: SettingsSystemSettingPublicSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPatchSystemBySystemDomainId,
  method: httpMethod.patch,
  url: `/API/settings/v1/system/${encodeURIComponent(systemDomainId)}/`,
  params: { systemDomainId },
  body,
  headers,
});

/**
 * `PUT /v1/system/{system_domain_id}/`
 *
 * Change system settings
 *
 *
 * Responses
 * - 200 - Returns changed system settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SettingsSystemSettingPublicSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/put_v1_system__system_domain_id__}
 */
export const httpPutSystemBySystemDomainId = (
  systemDomainId: string,
  body: SettingsSystemSettingPublicSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPutSystemBySystemDomainId,
  method: httpMethod.put,
  url: `/API/settings/v1/system/${encodeURIComponent(systemDomainId)}/`,
  params: { systemDomainId },
  body,
  headers,
});

/**
 * `DELETE /v1/team/{team_id}/`
 *
 * Delete team settings
 *
 * Required roles:
 *  - can_write_teams
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/delete_v1_team__team_id__}
 */
export const httpDeleteTeamByTeamId = (
  teamId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpDeleteTeamByTeamId,
  method: httpMethod.delete,
  url: `/API/settings/v1/team/${encodeURIComponent(teamId)}/`,
  params: { teamId },
  headers,
});

/**
 * `GET /v1/team/{team_id}/`
 *
 * Team settings
 *
 *
 * Responses
 * - 200 - Returns team settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Realm does not exist
 *
 * Response {@link SettingsGroupSettingPublicSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_team__team_id__}
 */
export const httpGetTeamByTeamId = (
  teamId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpGetTeamByTeamId,
  method: httpMethod.get,
  url: `/API/settings/v1/team/${encodeURIComponent(teamId)}/`,
  params: { teamId },
  headers,
});

/**
 * `PATCH /v1/team/{team_id}/`
 *
 * Change team settings
 *
 * Required roles:
 *  - can_write_teams
 *
 * Responses
 * - 200 - Returns changed team settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Restricted access, or share_expiration_time cannot be changed
 *
 * Response {@link SettingsGroupSettingPublicSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/patch_v1_team__team_id__}
 */
export const httpPatchTeamByTeamId = (
  teamId: string,
  body: SettingsGroupSettingPublicSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPatchTeamByTeamId,
  method: httpMethod.patch,
  url: `/API/settings/v1/team/${encodeURIComponent(teamId)}/`,
  params: { teamId },
  body,
  headers,
});

/**
 * `PUT /v1/team/{team_id}/`
 *
 * Change team settings
 *
 * Required roles:
 *  - can_write_teams
 *
 * Responses
 * - 200 - Returns changed team settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Restricted access, or share_expiration_time cannot be changed
 *
 * Response {@link SettingsGroupSettingPublicSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/put_v1_team__team_id__}
 */
export const httpPutTeamByTeamId = (
  teamId: string,
  body: SettingsGroupSettingPublicSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPutTeamByTeamId,
  method: httpMethod.put,
  url: `/API/settings/v1/team/${encodeURIComponent(teamId)}/`,
  params: { teamId },
  body,
  headers,
});

/**
 * `GET /v1/themes/`
 *
 * Get list of themes
 *
 * Required roles:
 *  - can_read_themes
 *
 * Responses
 * - 200 - Returns a list of themes
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SettingsThemesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_themes_}
 */
export const httpGetThemes = (headers?: IconikApiHeaders) => ({
  id: SettingsHttpGetThemes,
  method: httpMethod.get,
  url: '/API/settings/v1/themes/',

  headers,
});

/**
 * `POST /v1/themes/`
 *
 * Create a new theme
 *
 * Required roles:
 *  - can_write_themes
 *
 * Responses
 * - 201 - Returns a created theme
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link SettingsThemeSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/post_v1_themes_}
 */
export const httpPostThemes = (
  body: SettingsThemeCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPostThemes,
  method: httpMethod.post,
  url: '/API/settings/v1/themes/',

  body,
  headers,
});

/**
 * `DELETE /v1/themes/{theme_id}/`
 *
 * Delete a particular theme by id
 *
 * Required roles:
 *  - can_delete_themes
 *
 * Responses
 * - 204 - Successfully deleted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Theme does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/delete_v1_themes__theme_id__}
 */
export const httpDeleteThemesByThemeId = (
  themeId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpDeleteThemesByThemeId,
  method: httpMethod.delete,
  url: `/API/settings/v1/themes/${encodeURIComponent(themeId)}/`,
  params: { themeId },
  headers,
});

/**
 * `GET /v1/themes/{theme_id}/`
 *
 * Returns a particular theme by id
 *
 * Required roles:
 *  - can_read_themes
 *
 * Responses
 * - 200 - Returns a theme
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Theme does not exist
 *
 * Response {@link SettingsThemeSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_themes__theme_id__}
 */
export const httpGetThemesByThemeId = (
  themeId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpGetThemesByThemeId,
  method: httpMethod.get,
  url: `/API/settings/v1/themes/${encodeURIComponent(themeId)}/`,
  params: { themeId },
  headers,
});

export type SettingsThemeSchemaPartial = Partial<SettingsThemeSchema>;

/**
 * `PATCH /v1/themes/{theme_id}/`
 *
 * Update a theme
 *
 * Required roles:
 *  - can_write_themes
 *
 * Responses
 * - 200 - Returns an updated theme
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Theme does not exist
 *
 * Response {@link SettingsThemeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/patch_v1_themes__theme_id__}
 */
export const httpPatchThemesByThemeId = (
  themeId: string,
  body: SettingsThemeSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPatchThemesByThemeId,
  method: httpMethod.patch,
  url: `/API/settings/v1/themes/${encodeURIComponent(themeId)}/`,
  params: { themeId },
  body,
  headers,
});

/**
 * `PUT /v1/themes/{theme_id}/`
 *
 * Update a theme
 *
 * Required roles:
 *  - can_write_themes
 *
 * Responses
 * - 200 - Returns an updated theme
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Theme does not exist
 *
 * Response {@link SettingsThemeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/put_v1_themes__theme_id__}
 */
export const httpPutThemesByThemeId = (
  themeId: string,
  body: SettingsThemeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPutThemesByThemeId,
  method: httpMethod.put,
  url: `/API/settings/v1/themes/${encodeURIComponent(themeId)}/`,
  params: { themeId },
  body,
  headers,
});

/**
 * `DELETE /v1/user/{user_id}/`
 *
 * Delete user settings
 *
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/delete_v1_user__user_id__}
 */
export const httpDeleteUserByUserId = (
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpDeleteUserByUserId,
  method: httpMethod.delete,
  url: `/API/settings/v1/user/${encodeURIComponent(userId)}/`,
  params: { userId },
  headers,
});

/**
 * `GET /v1/user/{user_id}/`
 *
 * User settings
 *
 *
 * Responses
 * - 200 - Returns a user settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Realm does not exist
 *
 * Response {@link SettingsUserSettingSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/get_v1_user__user_id__}
 */
export const httpGetUserByUserId = (
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpGetUserByUserId,
  method: httpMethod.get,
  url: `/API/settings/v1/user/${encodeURIComponent(userId)}/`,
  params: { userId },
  headers,
});

export type SettingsUserSettingSchemaPartial =
  Partial<SettingsUserSettingSchema>;

/**
 * `PATCH /v1/user/{user_id}/`
 *
 * Change user settings
 *
 *
 * Responses
 * - 200 - Returns changed user settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Restricted access, or share_expiration_time cannot be changed
 *
 * Response {@link SettingsUserSettingSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/patch_v1_user__user_id__}
 */
export const httpPatchUserByUserId = (
  userId: string,
  body: SettingsUserSettingSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPatchUserByUserId,
  method: httpMethod.patch,
  url: `/API/settings/v1/user/${encodeURIComponent(userId)}/`,
  params: { userId },
  body,
  headers,
});

/**
 * `PUT /v1/user/{user_id}/`
 *
 * Change user settings
 *
 *
 * Responses
 * - 200 - Returns changed user settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Restricted access, or share_expiration_time cannot be changed
 *
 * Response {@link SettingsUserSettingSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/settings/spec/#/default/put_v1_user__user_id__}
 */
export const httpPutUserByUserId = (
  userId: string,
  body: SettingsUserSettingSchema,
  headers?: IconikApiHeaders,
) => ({
  id: SettingsHttpPutUserByUserId,
  method: httpMethod.put,
  url: `/API/settings/v1/user/${encodeURIComponent(userId)}/`,
  params: { userId },
  body,
  headers,
});
